// extracted by mini-css-extract-plugin
export default {"departments":"yJ-z","departmentHeading":"zJ-z","departmentSection":"AJ-z","departmentName":"BJ-z","departmentLink":"CJ-z","expandIcon":"DJ-z"};